import React, { Component, Fragment } from 'react'

import Img from 'gatsby-image'

import HeaderPage from '../components/header/headerpage'
import Footer from '../components/footer/footer'

import ModuloRicerca from '../components/homepage/moduloricerca'



class Cerca extends Component {
    constructor(props) {
        super(props)
        this.state = {

            loading: true,

        }

    }

    componentDidMount() {
        this.setState({ loading: false })
    }


    render() {

        return (
            <Fragment>
                {this.state.loading ? <p>loading</p> :
                    <Fragment>
                        <Img
                            sizes={this.props.data.cercaImage.sizes}
                            style={{
                                top: 0,
                                left: 0,
                                position: 'absolute',
                                objectFit: 'cover',
                                height: '100%',
                                width: '100%',
                                zIndex: -2
                            }}
                            imgStyle={{
                                objectPosition: 'center center',
                            }}
                        />
                        <div className="uk-position-cover uk-overlay-primary" style={{ zIndex: -1 }}></div>
                        <HeaderPage />
                        <div className="uk-flex uk-flex-middle uk-flex-center uk-light" data-uk-height-viewport="">

                            <ModuloRicerca titolo="Trova il miglior fotografo o videografo professionista" placeh="Seleziona la zona" bak="transparent" />
                        </div>
                        <Footer user={{ name: 'Prowedding', partitaIva: '12345678901' }} />

                    </Fragment>
                }
            </Fragment>
        )
    }
}



export default Cerca

export const pageQuery = graphql`
  query RicercaImageQuery {
    
    cercaImage: imageSharp(id: { regex: "/ricerca/" }) {
        sizes(maxWidth: 1920 ) {
          ...GatsbyImageSharpSizes
        }
      }
  }
`


// WEBPACK FOOTER //
// ./src/pages/ricerca.js